import React, { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';

interface CustomProps {
  readonly onChange: (event: {
    target: { name: string; value: string };
  }) => void;
  readonly name: string;
}

const CustomNumericFormatField = forwardRef<HTMLInputElement, CustomProps>(
  (props, ref) => {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values, { source }) => {
          // v5 also reports values set from the form; echoing those back would mark the field dirty.
          if (source !== 'event') return;
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        // Refunds get their sign from the modal, so the amount itself is never negative.
        allowNegative={false}
        decimalScale={2}
        thousandSeparator
        valueIsNumericString
      />
    );
  }
);

export { CustomNumericFormatField };
